import { router } from "@inertiajs/react";
import { Button, Modal, Select, Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useYearContext } from "../../hooks/useYearContext";
import { type Apprentice, getApprenticeOptions } from "../../models/apprentice";
import { createReportTypeRoute, getReportTypeOptions } from "../../models/enums/reportType";
import { FilterSelect } from "../select/FilterSelect";

type MassReportGeneratorProps = {
  close: () => void;
  opened: boolean;
  apprentices?: Apprentice[];
};

export function SingleReportGeneratorModal({ close, opened, apprentices = [] }: MassReportGeneratorProps) {
  const { pathWithYearContext } = useYearContext();
  const form = useForm({
    mode: "controlled",
    initialValues: {
      apprentice_id: "",
      report_type: "",
    },
    validate: {
      apprentice_id: (value) => (value ? null : "must be present"),
      report_type: (value) => (value ? null : "must be present"),
    },
  });

  const onSubmit = () => {
    router.post(pathWithYearContext(createReportTypeRoute[form.getValues().report_type]), form.getValues());
    form.reset();
    close();
  };

  return (
    <Modal title="Bericht erstellen" opened={opened} onClose={close}>
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Stack>
          <Select
            withAsterisk
            label="Typ"
            clearable
            data={getReportTypeOptions()}
            key={form.key("report_type")}
            {...form.getInputProps("report_type")}
          />
          <FilterSelect
            withAsterisk
            label="Lernende/r"
            clearable
            data={getApprenticeOptions(apprentices)}
            key={form.key("apprentice_id")}
            {...form.getInputProps("apprentice_id")}
          />
          <Button disabled={!form.isValid()} type="submit">
            Generieren
          </Button>
        </Stack>
      </form>
    </Modal>
  );
}
